// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"37e0cf06","394":"8e549de3"}[chunkId] + ".chunk.js";
};